import { useMemo } from "react";
import { useSelector } from "react-redux";

import { getScaleSegments, getSelectedSegment, getStyleChilds } from "../../../ducks/style/selectors";
import { useCurrentLayerStyle } from "./useCurrentLayerStyle";
import { getStyleChildIndex } from "../../../utils/style";
import { useDefaultScaleRange } from "../../../hooks/style/useDefaultScaleRange";
import { Style } from "../../../ducks/style/style";

export function useSegmentStyle(): Style {
  const style = useCurrentLayerStyle();
  const children = useSelector(getStyleChilds);
  const scaleSegments = useSelector(getScaleSegments);
  const selectedSegment = useSelector(getSelectedSegment);
  const defaultScaleRange = useDefaultScaleRange();

  return useMemo(() => {
    if (!children?.length || !scaleSegments?.length || selectedSegment === undefined) {
      return style;
    }

    return children[getStyleChildIndex(children, selectedSegment, defaultScaleRange)] || style;
  }, [children, defaultScaleRange, scaleSegments?.length, selectedSegment, style]);
}
